<div class="flex justify-center">
  <psc-transactions-table
    class="w-full md:w-3/4 xl:w-4/5 block"
    [showPlantName]="true"></psc-transactions-table>

</div>
